import { render, staticRenderFns } from "./ValidateUser.vue?vue&type=template&id=51bca02e&scoped=true&"
import script from "./ValidateUser.vue?vue&type=script&lang=js&"
export * from "./ValidateUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bca02e",
  null
  
)

export default component.exports